import { useState, useEffect } from 'react';
import { getStats } from '../../api';
import MetricCard from '../shared/MetricCard';

export default function StatsBar() {
  const [stats, setStats] = useState([]);

  useEffect(() => {
    getStats().then(setStats).catch(() => {});
  }, []);

  if (stats.length === 0) return null;

  return (
    <section className="py-16 bg-blue-600">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map(s => <MetricCard key={s.id} value={s.value} label={s.label} detail={s.detail} />)}
        </div>
      </div>
    </section>
  );
}
